import { Link } from "react-router-dom";
import ContentCard from "@/components/feature/ContentCard";
import { getHotContent } from "@/lib/content";

export default function HotRecommend() {
  const hot = getHotContent(8);

  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16">
      <div className="mb-7 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-semibold tracking-[0.2em] text-accent-600">TRENDING</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            热门影视推荐
          </h2>
        </div>
        <p className="max-w-md text-sm text-foreground-600">
          根据站内热度与话题度整理，点击封面即可进入作品详情与剧情介绍。
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
        {hot.map((item) => (
          <ContentCard key={item.id} item={item} />
        ))}
      </div>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-movie-2-line" />
          浏览全部电影
        </Link>
        <Link
          to="/category/tv"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
        >
          <i className="ri-tv-2-line" />
          浏览全部电视剧
        </Link>
      </div>
    </section>
  );
}